if (!customElements.get('hero-slider')) {
  class HeroSlider extends SwiperComponent {
    constructor() {
      super();
      this.lastActiveIndex = null;
    }

    connectedCallback() {
      // Override parent's connectedCallback
      // We'll use SwiperComponent's init method
      this.swiperOptions = this.buildHeroSliderOptions();
      this.swiperInitialized = false;
      this.section = this.closest('section');

// Let the browser paint the first hero image before initializing Swiper.
requestAnimationFrame(() => {
  setTimeout(() => {
    this.init();
  }, 0);
});

      // Keep Shopify Theme Editor support
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => this.init());
        window.addEventListener('shopify:section:select', () => this.init());
      }

      // Hero-specific event listeners
      window.addEventListener('shopify:block:select', e => {
        if (this.swiper && e.target.closest('hero-slider') === this) {
          const selectedSlideIndex = +e.target.dataset.index;
          this.swiper.slideTo(selectedSlideIndex, 600);
        }
      });

      this.addKeyboardNavigation();
    }

    buildHeroSliderOptions() {
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval || 5000
      };

      return {
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (i, className) {
            return `
              <button class="${className}">
                <span>0${i + 1}</span>
                <svg class="square-progress" width="26" height="26">
                  <rect
                    class="square-origin"
                    width="26"
                    height="26"
                    rx="5"
                    ry="5"
                  />
                </svg>
                <svg
                  class="progress"
                  width="1.8rem"
                  height="1.8rem"
                  style="inset-inline-start: ${0 - (i * 2.4 + 3.4)}rem"
                >
                  <circle
                    class="circle-origin"
                    r="0.8rem"
                    cx="0.95rem"
                    cy="0.95rem"
                  ></circle>
                </svg>
              </button>
            `;
          }
        },
        autoplay: this.dataset.autoplay === 'true' ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this)
        }
      };
    }

    init() {
      if (this.swiperInitialized) return;

      this.swiperInitialized = true;

      // Use custom Swiper options for HeroSlider
      this.swiper = new Swiper(this, this.swiperOptions);

      // Maintain slider property for backward compatibility
      this.slider = this.swiper;
    }

    handleSlideChange(swiper) {
      this.handleSlideChangeAnimations(swiper);

      /** Change header menu color for active slide */
      const headerInner = document.querySelector('.header__inner');
      const heroInners = document.querySelectorAll('.hero__inner');

      if (!headerInner || !heroInners.length) {
        return;
      }

      const activeHeroInner = heroInners[swiper.activeIndex];

      if (!activeHeroInner) {
        return;
      }

      // Change --transparent-header-menu-text-color value
      document.documentElement.style.setProperty(
        '--transparent-header-menu-text-color',
        activeHeroInner.dataset.headerMenuTextColor
      );
    }

    /**
     * Get direction & set custom transitions
     * with delay for content animation items
     */
    handleSlideChangeAnimations(swiper) {
      let delay = 300;

      const queryElement = `[data-index="${swiper.activeIndex}"]`;
      const activeSlide = swiper.wrapperEl.querySelector(queryElement);

      if (!activeSlide) {
        return;
      }

      const queryArray = [
        ...activeSlide.querySelectorAll('.hero__animation')
      ];

      if (!queryArray.length) {
        return;
      }

      const allowMobileAnimation =
        swiper.wrapperEl.closest('.hero__content')?.dataset.animationMobile === 'true';

      if (!allowMobileAnimation && DeviceDetector.isMobile()) {
        queryArray.forEach(element => {
          element.classList.remove('in-delay');
        });

        return;
      }

      // Set all elements in delay
      queryArray.forEach(element => {
        element.classList.add('in-delay');
      });

      // Get direction and set transitions
      if (this.lastActiveIndex > swiper.activeIndex) {
        delay = 650 + delay;

        swiper.wrapperEl.style.transitionDuration = '1000ms';
        swiper.wrapperEl.style.transitionTimingFunction =
          'cubic-bezier(0.45, 0.00, 0.15, 0.95)';
      } else if (this.lastActiveIndex < swiper.activeIndex) {
        delay = 1000 + delay;

        swiper.wrapperEl.style.transitionDuration = '1000ms';
        swiper.wrapperEl.style.transitionTimingFunction =
          'cubic-bezier(0.45, 0.00, 0.15, 0.95)';
      }

      // Set calculated delay per item
      setTimeout(() => {
        if (this.lastActiveIndex > swiper.activeIndex) {
          delay = 325 + delay;
        } else if (this.lastActiveIndex < swiper.activeIndex) {
          delay = 500 + delay;
        }

        queryArray.forEach((element, index) => {
          if (index === 1) {
            delay = delay + 50;
          } else if (index === 2) {
            delay = delay + 175;
          } else if (index === 3) {
            delay = delay + 300;
          }

          element.classList.remove('in-delay');
        });
      }, delay);

      // Set last active index
      this.lastActiveIndex = swiper.activeIndex;
    }

    addKeyboardNavigation() {
      document.addEventListener('keydown', event => {
        if (!this.isInViewport()) {
          return;
        }

        if (event.key === 'ArrowRight') {
          const nextButton = this.querySelector('.swiper-button--next');

          if (nextButton) {
            nextButton.click();
          }
        }

        if (event.key === 'ArrowLeft') {
          const prevButton = this.querySelector('.swiper-button--prev');

          if (prevButton) {
            prevButton.click();
          }
        }
      });
    }

    isInViewport() {
      const rect = this.getBoundingClientRect();

      return (
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0
      );
    }
  }

  customElements.define('hero-slider', HeroSlider);
}